import React, {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import Stack from '@mui/material/Stack'
import Page from '../../components/Page'
import useUser from '../../hooks/useUser'
import CreateForm from '../../components/alarms/Create'
import {createAlarm} from '../../services/alarms'
import {getEvaluations} from '../../services/evaluations'
import {getModels} from '../../services/models'
import type {Alarm as AlarmType, Evaluation, Model} from '../../services/types'
import Path from '../../routeLinks'

const CreateAlarm: React.FC = () => {
  const {user} = useUser()
  const navigate = useNavigate()
  const [allEvals, setEvaluations] = useState([] as Evaluation[])
  const [allModels, setModels] = useState([] as Model[])

  useEffect(() => {
    const getter = async () => {
      getEvaluations({filters: {fields: ['name']}}).then((r) =>
        setEvaluations(r.items as Evaluation[])
      )
      getModels({filters: {fields: ['name']}}).then((r) => setModels(r.items as Model[]))
    }
    getter()
  }, [])

  const saveAlarm = async (a: AlarmType) => {
    try {
      const {id} = await createAlarm({...a, owner: user || undefined})
      navigate(Path.alarms.show(id))
    } catch (e) {
      const error = await e
      return 'Error while creating alarm: ' + error
    }
    return null
  }

  return (
    <Page title="Create alarm" showTitle>
      <Stack direction="column" spacing={7} sx={{m: 5}}>
        <CreateForm onSave={saveAlarm} allEvals={allEvals} allModels={allModels} />
      </Stack>
    </Page>
  )
}

export default CreateAlarm
